import fetch from 'utils/fetch';

export function accountList(accountBegin,accountEnd,imsiBegin,imsiEnd,productId,accoutStatus,agent,merchant,psize,currentPage) {
    const data = {
        accountBegin,
        accountEnd,
        imsiBegin,
        imsiEnd,
        productId,
        accoutStatus,
        agent,
        merchant,
        psize,
        currentPage
    };
    return fetch({
        url: '/accountList',
        method: 'get',
        params : data,
        timeout: 60 * 1000
    });
}
export function enablement(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/enablement',
        method: 'post',
        data
    });
}

export function recharge(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/recharge',
        method: 'post',
        data
    });
}
export  function closeAccount(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/closeAccount',
        method: 'put',
        data
    });
}
export  function batchCloseAccount(requestData) {
    const data = requestData;
    return fetch({
        url: '/batchCloseAccount',
        method: 'put',
        data
    });
}
export function checkRecharge(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/checkRecharge',
        method: 'post',
        data
    });
}

export function excelRecharge(requestData) {
    const data = requestData;
    return fetch({
        url: '/importExcelRecharge',
        method: 'post',
        data
    });
}






// WEBPACK FOOTER //
// ./src/api/account.js